import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/App';
import { ContentfulProvider } from './context/ContentfulContext';

import './components/styles/reset.css';
import './components/styles/global.css';

async function prepare() {
  if (process.env.NODE_ENV === 'development') {
    const { worker } = await import('./mocks/browser');
    return worker.start({ onUnhandledRequest: 'bypass' });
  }
}

prepare().then(() => {
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Root element #root not found');
  }
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ContentfulProvider>
        <App />
      </ContentfulProvider>
    </React.StrictMode>,
  );
});
